export function getMessageBubbleRadius(
  isFirst: boolean,
  isLast: boolean,
  role: "user" | "non-user"
): string {
  // Single message (first and last)
  if (isFirst && isLast) {
    return "rounded-3xl";
  }

  // First message in block
  if (isFirst && !isLast) {
    return role === "user"
      ? "rounded-l-3xl rounded-tr-3xl rounded-br-[3px]"
      : "rounded-r-3xl rounded-tl-3xl rounded-bl-[3px]";
  }

  // Last message in block
  if (isLast && !isFirst) {
    return role === "user"
      ? "rounded-l-3xl rounded-tl-3xl rounded-bl-3xl rounded-br-3xl"
      : "rounded-r-3xl rounded-tr-3xl rounded-br-3xl rounded-bl-3xl";
  }

  // Middle message in block
  return role === "user"
    ? "rounded-l-3xl rounded-r-[3px]"
    : "rounded-r-3xl rounded-l-[3px]";
}
